<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="container-header">
    <lms-yard-local-container-header (filterDataEvent)='filterDataEvent($event)' [yardLocalDetail]='yardLocalDetail' [stationDetailArr]='stationDetailArr'></lms-yard-local-container-header>
</div>
<div class="container-data" *ngIf="stationDetailArr && stationDetailArr.length > 0">
    <lms-yard-local-container-data [locateLocoId]='locateLocoId' (showStationMenu)='showStationContextMenu($event)' (onLocoSelect)='showLocoContextMenu($event);'  (locoOrStationSelectionEvent)='locoOrStationSelectionEvent($event)' [stationDetailArr]='stationDetailArr'></lms-yard-local-container-data>
</div>